export enum MODULES_ICON {
  'Analyze' = 'one-icon-outline-activity',
  'Sense' = 'one-icon-outline-happy-face',
  'Create' = 'one-icon-tools',
  'Internal Tools' = 'one-icon-wrench'
}
